const actionsDe = {
  CALL: 'Anrufen',
  PLAN_CALLBACK: 'Rückruf planen',
  CREATE_TASK: 'Aufgabe erstellen',
  RESOLVE_COMPLAINT: 'Reklamation klären',
  REVIEW_RISK: 'Risiko prüfen',
  REVIEW_PAYMENT: 'Zahlung prüfen',
  FOLLOW_UP_QUOTE: 'Angebot nachfassen',
  CREATE_QUOTE: 'Angebot erstellen',
  REVIEW_CART: 'Warenkorb prüfen',
  ASSIGN_OWNER: 'Zuständigkeit zuweisen',
  REVIEW_COMMERCIAL_TERMS: 'Konditionen prüfen',
  OPEN_CUSTOMER: 'Kundenakte öffnen',
};
const actionsEn = {
  CALL: 'Call',
  PLAN_CALLBACK: 'Plan callback',
  CREATE_TASK: 'Create task',
  RESOLVE_COMPLAINT: 'Resolve complaint',
  REVIEW_RISK: 'Review risk',
  REVIEW_PAYMENT: 'Review payment',
  FOLLOW_UP_QUOTE: 'Follow up quote',
  CREATE_QUOTE: 'Create quote',
  REVIEW_CART: 'Review cart',
  ASSIGN_OWNER: 'Assign owner',
  REVIEW_COMMERCIAL_TERMS: 'Review commercial terms',
  OPEN_CUSTOMER: 'Open customer record',
};
const parametersDe = {
  thresholdDays: 'Schwelle in Tagen',
  minimumDeviationDays: 'Mindestabweichung in Tagen',
  comparisonDays: 'Vergleichszeitraum in Tagen',
  declinePercent: 'Umsatzrückgang in Prozent',
  minimumRevenue: 'Mindestumsatz',
  minimumDeviationRatio: 'Minimale Rhythmusabweichung',
  lookbackOrderCount: 'Verglichene Bestellungen',
  minimumOccurrences: 'Mindestvorkommen',
  missingCycles: 'Fehlende Bestellzyklen',
  thresholdHours: 'Schwelle in Stunden',
  leadDays: 'Vorlauf in Tagen',
  attributionWindowDays: 'Attributionsfenster in Tagen',
  escalationAfterDays: 'Eskalieren nach Tagen',
  escalationPriority: 'Eskalationspriorität',
};
const parametersEn = {
  thresholdDays: 'Threshold in days',
  minimumDeviationDays: 'Minimum deviation in days',
  comparisonDays: 'Comparison period in days',
  declinePercent: 'Revenue decline percent',
  minimumRevenue: 'Minimum revenue',
  minimumDeviationRatio: 'Minimum cadence deviation',
  lookbackOrderCount: 'Orders compared',
  minimumOccurrences: 'Minimum occurrences',
  missingCycles: 'Missing order cycles',
  thresholdHours: 'Threshold in hours',
  leadDays: 'Lead time in days',
  attributionWindowDays: 'Attribution window in days',
  escalationAfterDays: 'Escalate after days',
  escalationPriority: 'Escalation priority',
};
const conditionsDe = {
  customerGroups: 'Kundengruppen',
  industries: 'Branchen',
  regions: 'Regionen',
  salesTerritories: 'Vertriebsgebiete',
  revenueClasses: 'Umsatzklassen',
  customerIds: 'Bestimmte Kunden-IDs',
  minimumDataCount: 'Mindestanzahl Bestellungen',
  activeFrom: 'Aktiv ab',
  activeUntil: 'Aktiv bis',
  prospectStatuses: 'Interessentenstatus',
  riskStatuses: 'Risiko- und Sperrstatus',
  weekdays: 'Auswertung an Wochentagen',
  customFields: 'Zusatzfeld-Kriterien (JSON)',
  customFieldsHint:
    'Objekt aus Feldschlüsseln und erlaubten Werten, zum Beispiel {"channel":"retail"}.',
};
const conditionsEn = {
  customerGroups: 'Customer groups',
  industries: 'Industries',
  regions: 'Regions',
  salesTerritories: 'Sales territories',
  revenueClasses: 'Revenue classes',
  customerIds: 'Specific customer IDs',
  minimumDataCount: 'Minimum order count',
  activeFrom: 'Active from',
  activeUntil: 'Active until',
  prospectStatuses: 'Prospect statuses',
  riskStatuses: 'Risk and block statuses',
  weekdays: 'Evaluate on weekdays',
  customFields: 'Custom-field criteria (JSON)',
  customFieldsHint:
    'An object of field keys and permitted values, for example {"channel":"retail"}.',
};
const weekdaysDe = {
  '1': 'Montag',
  '2': 'Dienstag',
  '3': 'Mittwoch',
  '4': 'Donnerstag',
  '5': 'Freitag',
  '6': 'Samstag',
  '7': 'Sonntag',
};
const weekdaysEn = {
  '1': 'Monday',
  '2': 'Tuesday',
  '3': 'Wednesday',
  '4': 'Thursday',
  '5': 'Friday',
  '6': 'Saturday',
  '7': 'Sunday',
};
const monthsDe = {
  '1': 'Jan',
  '2': 'Feb',
  '3': 'Mär',
  '4': 'Apr',
  '5': 'Mai',
  '6': 'Jun',
  '7': 'Jul',
  '8': 'Aug',
  '9': 'Sep',
  '10': 'Okt',
  '11': 'Nov',
  '12': 'Dez',
};
const monthsEn = {
  '1': 'Jan',
  '2': 'Feb',
  '3': 'Mar',
  '4': 'Apr',
  '5': 'May',
  '6': 'Jun',
  '7': 'Jul',
  '8': 'Aug',
  '9': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};
const riskDe = {
  NORMAL: 'Normal',
  WATCHLIST: 'Beobachtung',
  DELIVERY_LOCK: 'Liefersperre',
  SALES_LOCK: 'Verkaufssperre',
  COLLECTION: 'Inkasso',
  INSOLVENCY: 'Insolvenz',
};
const riskEn = {
  NORMAL: 'Normal',
  WATCHLIST: 'Watchlist',
  DELIVERY_LOCK: 'Delivery block',
  SALES_LOCK: 'Sales block',
  COLLECTION: 'Collections',
  INSOLVENCY: 'Insolvency',
};

export const salesRuleAdminDe = {
  title: 'Vertriebsregeln verwalten',
  subtitle: 'Nachvollziehbare Empfehlungen sicher konfigurieren, prüfen und planen.',
  tabs: {
    label: 'Regelverwaltung',
    rules: 'Regeln',
    cadence: 'Bestellrhythmus',
    automation: 'Automatik & Läufe',
  },
  rules: 'Vertriebsregeln',
  newRule: 'Neue Regel',
  newRuleHint: 'Neue Regeln starten sicher im Testmodus und deaktiviert.',
  search: 'Regeln durchsuchen',
  empty: 'Wählen Sie eine Regel aus.',
  basic: 'Grundkonfiguration',
  thresholds: 'Schwellenwerte und Eskalation',
  thresholdsHint: 'Nur deterministische Werte beeinflussen Auslösung und Priorität.',
  targets: 'Zielgruppe und Zuständigkeit',
  targetsHint: 'Leere Kriterien gelten für alle passenden Kunden oder Interessenten.',
  commaSeparated: 'Mehrere Werte mit Komma trennen.',
  fields: {
    name: 'Name',
    key: 'Eindeutiger Schlüssel',
    type: 'Regeltyp',
    priority: 'Grundpriorität',
    action: 'Empfohlene Aktion',
    description: 'Beschreibung',
    active: 'Regel aktiviert',
    activeHint: 'Produktive Regeln benötigen zuvor eine aktuelle Simulation.',
    testMode: 'Testmodus',
    testModeHint: 'Wird ausgewertet, erzeugt aber keine Empfehlungen.',
    dueInDays: 'Fälligkeit nach Tagen',
    expiresAfterDays: 'Ablauf nach Tagen',
    defaultResponsible: 'Standardverantwortlicher',
    defaultTeam: 'Standardteam',
  },
  parameters: parametersDe,
  conditions: conditionsDe,
  actions: actionsDe,
  weekdays: weekdaysDe,
  months: monthsDe,
  riskStatuses: riskDe,
  status: { active: 'Aktiv', testMode: 'Testmodus', inactive: 'Inaktiv' },
  assignment: { customerOwner: 'Zuständiger des Kunden', unassigned: 'Nicht zugewiesen' },
  changeReason: 'Änderungsgrund',
  changeReasonHint: 'Der Grund erscheint im vollständigen Änderungsverlauf.',
  changeReasonRequired: 'Bitte einen nachvollziehbaren Änderungsgrund eingeben.',
  invalid: 'Bitte prüfen Sie die Regelwerte.',
  invalidCustomFields: 'Die Zusatzfeld-Kriterien müssen ein gültiges JSON-Objekt sein.',
  invalidVersion: 'Diese historische Version ist nicht mehr gültig.',
  simulate: 'Simulation starten',
  saved: 'Regel gespeichert.',
  created: 'Regel im Testmodus angelegt.',
  restored: 'Version wiederhergestellt.',
  versions: 'Versionen',
  versionsTitle: 'Änderungsverlauf',
  versionsHint:
    'Snapshots bleiben unverändert erhalten. Eine Wiederherstellung erzeugt eine neue Version.',
  version: 'Version {{version}}',
  noChangeReason: 'Kein Änderungsgrund',
  restore: 'Wiederherstellen',
  restoreReason: 'Version {{version}} wiederhergestellt',
  simulation: {
    title: 'Regelsimulation',
    description:
      'Vorschau mit echten, mandantengetrennten Daten – ohne Aufgaben oder Empfehlungen anzulegen.',
    testOnly: 'Sichere Vorschau',
    noWrites: 'Die Simulation verändert keine Kunden, Aufgaben oder Empfehlungen.',
    totalCustomers: 'Geprüfte Kunden',
    affectedCustomers: 'Betroffene Kunden',
    estimatedTasks: 'Mögliche Aufgaben',
    excludedCustomers: 'Explizit ausgeschlossen',
    outsideTargetGroup: 'Außerhalb der Zielgruppe',
    conflictCustomers: 'Mögliche Konflikte',
    conflicts: 'Konflikte erkannt',
    conflictsHint:
      'Kontakt-, Risiko-, Zahlungs- und Reklamationssperren werden in der produktiven Auswertung vorrangig behandelt.',
    examples: 'Beispielbegründungen',
    noExamples: 'Für diese Konfiguration wurde kein Treffer gefunden.',
    distribution: 'Geschätzte Verteilung',
    noDistribution: 'Keine Zuweisungen zu verteilen.',
    confirm: 'Prüfung bestätigen und speichern',
  },
  automation: {
    title: 'Automatische Auswertung',
    description: 'Mandantenbezogene, idempotente Batch-Verarbeitung in lokaler Zeitzone.',
    enabled: 'Automatische Läufe aktiv',
    interval: 'Intervall in Minuten',
    batchSize: 'Kunden pro Batch',
    attributionWindow: 'Zeitfenster der Umsatzzuordnung in Tagen',
    quietStart: 'Ruhezeit beginnt',
    quietEnd: 'Ruhezeit endet',
    workdays: 'Arbeitstage',
    saved: 'Ausführungsplan gespeichert.',
    runNow: 'Jetzt neu berechnen',
    runQueued: 'Neuberechnung wurde eingeplant.',
    runDurable: 'Lauf wurde gespeichert und wird nach Wiederherstellung der Queue fortgesetzt.',
    runs: 'Letzte Läufe',
    nextRun: 'Nächster geplanter Lauf: {{value}}',
    runCounts: '{{processed}} von {{total}} Kunden, {{found}} Treffer',
  },
  runStatus: {
    QUEUED: 'Eingeplant',
    RUNNING: 'Läuft',
    COMPLETED: 'Abgeschlossen',
    FAILED: 'Fehlgeschlagen',
  },
  cadence: {
    title: 'Standard-Bestellrhythmen',
    description:
      'Fallbacks für neue Kunden und saisonale Segmente; individuelle Historie bleibt vorrangig.',
    empty:
      'Noch keine Richtlinie vorhanden. Ohne Richtlinie gilt der dokumentierte Systemstandard.',
    edit: 'Richtlinie bearbeiten',
    scope: 'Geltungsbereich',
    tenant: 'Gesamter Mandant',
    segment: 'Kundengruppe',
    customerGroup: 'Kundengruppe',
    minOrderCount: 'Bestellungen für individuelle Prognose',
    defaultIntervalDays: 'Standardintervall in Tagen',
    dueSoonDays: 'Demnächst fällig ab Tagen',
    overdueTolerancePercent: 'Überfälligkeitstoleranz in Prozent',
    lookbackOrderCount: 'Maximal berücksichtigte Bestellungen',
    activeMonths: 'Aktive Saisonmonate',
    summary: '{{interval}} Tage Standard; individuell ab {{minimum}} Bestellungen',
    saved: 'Bestellrhythmus-Richtlinie gespeichert.',
  },
} as const;

export const salesRuleAdminEn = {
  title: 'Manage sales rules',
  subtitle: 'Configure, review and schedule explainable recommendations safely.',
  tabs: {
    label: 'Rule management',
    rules: 'Rules',
    cadence: 'Reorder cadence',
    automation: 'Automation & runs',
  },
  rules: 'Sales rules',
  newRule: 'New rule',
  newRuleHint: 'New rules start safely disabled and in test mode.',
  search: 'Search rules',
  empty: 'Select a rule.',
  basic: 'Basic configuration',
  thresholds: 'Thresholds and escalation',
  thresholdsHint: 'Only deterministic values affect triggering and priority.',
  targets: 'Audience and responsibility',
  targetsHint: 'Empty criteria apply to all matching customers or prospects.',
  commaSeparated: 'Separate multiple values with commas.',
  fields: {
    name: 'Name',
    key: 'Unique key',
    type: 'Rule type',
    priority: 'Base priority',
    action: 'Suggested action',
    description: 'Description',
    active: 'Rule enabled',
    activeHint: 'Production rules require a current simulation first.',
    testMode: 'Test mode',
    testModeHint: 'Evaluated without creating recommendations.',
    dueInDays: 'Due after days',
    expiresAfterDays: 'Expires after days',
    defaultResponsible: 'Default owner',
    defaultTeam: 'Default team',
  },
  parameters: parametersEn,
  conditions: conditionsEn,
  actions: actionsEn,
  weekdays: weekdaysEn,
  months: monthsEn,
  riskStatuses: riskEn,
  status: { active: 'Active', testMode: 'Test mode', inactive: 'Inactive' },
  assignment: { customerOwner: 'Customer owner', unassigned: 'Unassigned' },
  changeReason: 'Reason for change',
  changeReasonHint: 'The reason appears in the complete change history.',
  changeReasonRequired: 'Enter a meaningful reason for the change.',
  invalid: 'Please check the rule values.',
  invalidCustomFields: 'Custom-field criteria must be a valid JSON object.',
  invalidVersion: 'This historical version is no longer valid.',
  simulate: 'Run simulation',
  saved: 'Rule saved.',
  created: 'Rule created in test mode.',
  restored: 'Version restored.',
  versions: 'Versions',
  versionsTitle: 'Change history',
  versionsHint: 'Snapshots remain immutable. Restoring creates a new version.',
  version: 'Version {{version}}',
  noChangeReason: 'No change reason',
  restore: 'Restore',
  restoreReason: 'Restored version {{version}}',
  simulation: {
    title: 'Rule simulation',
    description:
      'Preview using real tenant-isolated data without creating tasks or recommendations.',
    testOnly: 'Safe preview',
    noWrites: 'The simulation changes no customers, tasks or recommendations.',
    totalCustomers: 'Customers checked',
    affectedCustomers: 'Customers affected',
    estimatedTasks: 'Potential tasks',
    excludedCustomers: 'Explicitly excluded',
    outsideTargetGroup: 'Outside audience',
    conflictCustomers: 'Potential conflicts',
    conflicts: 'Conflicts detected',
    conflictsHint:
      'Contact, risk, payment and complaint blocks take priority in production evaluation.',
    examples: 'Example reasons',
    noExamples: 'No match was found for this configuration.',
    distribution: 'Estimated distribution',
    noDistribution: 'No assignments to distribute.',
    confirm: 'Confirm review and save',
  },
  automation: {
    title: 'Automatic evaluation',
    description: 'Tenant-specific, idempotent batch processing in local time.',
    enabled: 'Automatic runs enabled',
    interval: 'Interval in minutes',
    batchSize: 'Customers per batch',
    attributionWindow: 'Revenue attribution window in days',
    quietStart: 'Quiet hours start',
    quietEnd: 'Quiet hours end',
    workdays: 'Working days',
    saved: 'Run schedule saved.',
    runNow: 'Recalculate now',
    runQueued: 'Recalculation was queued.',
    runDurable: 'The run was stored and resumes when the queue is available.',
    runs: 'Recent runs',
    nextRun: 'Next scheduled run: {{value}}',
    runCounts: '{{processed}} of {{total}} customers, {{found}} matches',
  },
  runStatus: { QUEUED: 'Queued', RUNNING: 'Running', COMPLETED: 'Completed', FAILED: 'Failed' },
  cadence: {
    title: 'Default reorder cadences',
    description:
      'Fallbacks for new customers and seasonal segments; individual history takes precedence.',
    empty: 'No policy yet. The documented system default applies without a policy.',
    edit: 'Edit policy',
    scope: 'Scope',
    tenant: 'Entire tenant',
    segment: 'Customer group',
    customerGroup: 'Customer group',
    minOrderCount: 'Orders needed for individual forecast',
    defaultIntervalDays: 'Default interval in days',
    dueSoonDays: 'Due soon within days',
    overdueTolerancePercent: 'Overdue tolerance percent',
    lookbackOrderCount: 'Maximum orders considered',
    activeMonths: 'Active seasonal months',
    summary: '{{interval}} day default; individual from {{minimum}} orders',
    saved: 'Reorder cadence policy saved.',
  },
} as const;

export const salesRuleAdminFr = {
  ...salesRuleAdminEn,
  title: 'Gérer les règles commerciales',
  subtitle: 'Configurer et vérifier des recommandations explicables en toute sécurité.',
  tabs: {
    label: 'Gestion des règles',
    rules: 'Règles',
    cadence: 'Rythme de commande',
    automation: 'Automatisation et exécutions',
  },
  rules: 'Règles commerciales',
  newRule: 'Nouvelle règle',
  search: 'Rechercher des règles',
  simulate: 'Lancer la simulation',
  saved: 'Règle enregistrée.',
  created: 'Règle créée en mode test.',
  restored: 'Version restaurée.',
  fields: {
    ...salesRuleAdminEn.fields,
    name: 'Nom',
    type: 'Type de règle',
    priority: 'Priorité de base',
    action: 'Action suggérée',
    description: 'Description',
    active: 'Règle activée',
    testMode: 'Mode test',
    dueInDays: 'Échéance après jours',
    expiresAfterDays: 'Expiration après jours',
    defaultResponsible: 'Responsable par défaut',
    defaultTeam: 'Équipe par défaut',
  },
  parameters: {
    ...parametersEn,
    thresholdDays: 'Seuil en jours',
    comparisonDays: 'Période de comparaison en jours',
    declinePercent: 'Baisse du chiffre en pourcentage',
    escalationAfterDays: 'Escalader après jours',
    escalationPriority: 'Priorité d’escalade',
  },
  conditions: {
    ...conditionsEn,
    customerGroups: 'Groupes de clients',
    industries: 'Secteurs',
    regions: 'Régions',
    salesTerritories: 'Zones commerciales',
    revenueClasses: 'Classes de chiffre',
    minimumDataCount: 'Nombre minimal de commandes',
    activeFrom: 'Actif à partir du',
    activeUntil: 'Actif jusqu’au',
    prospectStatuses: 'Statuts des prospects',
    riskStatuses: 'Statuts de risque et blocage',
    weekdays: 'Jours d’évaluation',
  },
  actions: actionsEn,
  weekdays: {
    '1': 'Lundi',
    '2': 'Mardi',
    '3': 'Mercredi',
    '4': 'Jeudi',
    '5': 'Vendredi',
    '6': 'Samedi',
    '7': 'Dimanche',
  },
  months: monthsEn,
  riskStatuses: riskEn,
} as const;
export const salesRuleAdminEs = {
  ...salesRuleAdminEn,
  title: 'Gestionar reglas comerciales',
  subtitle: 'Configure y revise recomendaciones explicables de forma segura.',
  tabs: {
    label: 'Gestión de reglas',
    rules: 'Reglas',
    cadence: 'Ritmo de pedidos',
    automation: 'Automatización y ejecuciones',
  },
  rules: 'Reglas comerciales',
  newRule: 'Nueva regla',
  search: 'Buscar reglas',
  simulate: 'Ejecutar simulación',
  saved: 'Regla guardada.',
  created: 'Regla creada en modo de prueba.',
  restored: 'Versión restaurada.',
  fields: {
    ...salesRuleAdminEn.fields,
    name: 'Nombre',
    type: 'Tipo de regla',
    priority: 'Prioridad base',
    action: 'Acción sugerida',
    description: 'Descripción',
    active: 'Regla activa',
    testMode: 'Modo de prueba',
    dueInDays: 'Vence después de días',
    expiresAfterDays: 'Caduca después de días',
    defaultResponsible: 'Responsable predeterminado',
    defaultTeam: 'Equipo predeterminado',
  },
  parameters: {
    ...parametersEn,
    thresholdDays: 'Umbral en días',
    comparisonDays: 'Período de comparación en días',
    declinePercent: 'Descenso de ingresos en porcentaje',
    escalationAfterDays: 'Escalar después de días',
    escalationPriority: 'Prioridad de escalado',
  },
  conditions: {
    ...conditionsEn,
    customerGroups: 'Grupos de clientes',
    industries: 'Sectores',
    regions: 'Regiones',
    salesTerritories: 'Territorios de ventas',
    revenueClasses: 'Clases de ingresos',
    minimumDataCount: 'Número mínimo de pedidos',
    activeFrom: 'Activo desde',
    activeUntil: 'Activo hasta',
    prospectStatuses: 'Estados de prospecto',
    riskStatuses: 'Estados de riesgo y bloqueo',
    weekdays: 'Días de evaluación',
  },
  actions: actionsEn,
  weekdays: {
    '1': 'Lunes',
    '2': 'Martes',
    '3': 'Miércoles',
    '4': 'Jueves',
    '5': 'Viernes',
    '6': 'Sábado',
    '7': 'Domingo',
  },
  months: monthsEn,
  riskStatuses: riskEn,
} as const;
export const salesRuleAdminTr = {
  ...salesRuleAdminEn,
  title: 'Satış kurallarını yönet',
  subtitle: 'Açıklanabilir önerileri güvenle yapılandırın ve inceleyin.',
  tabs: {
    label: 'Kural yönetimi',
    rules: 'Kurallar',
    cadence: 'Sipariş ritmi',
    automation: 'Otomasyon ve çalışmalar',
  },
  rules: 'Satış kuralları',
  newRule: 'Yeni kural',
  search: 'Kural ara',
  simulate: 'Simülasyonu çalıştır',
  saved: 'Kural kaydedildi.',
  created: 'Kural test modunda oluşturuldu.',
  restored: 'Sürüm geri yüklendi.',
  fields: {
    ...salesRuleAdminEn.fields,
    name: 'Ad',
    type: 'Kural türü',
    priority: 'Temel öncelik',
    action: 'Önerilen eylem',
    description: 'Açıklama',
    active: 'Kural etkin',
    testMode: 'Test modu',
    dueInDays: 'Gün sonra son tarih',
    expiresAfterDays: 'Gün sonra sona erer',
    defaultResponsible: 'Varsayılan sorumlu',
    defaultTeam: 'Varsayılan ekip',
  },
  parameters: {
    ...parametersEn,
    thresholdDays: 'Gün eşiği',
    comparisonDays: 'Gün olarak karşılaştırma dönemi',
    declinePercent: 'Gelir düşüş yüzdesi',
    escalationAfterDays: 'Gün sonra yükselt',
    escalationPriority: 'Yükseltme önceliği',
  },
  conditions: {
    ...conditionsEn,
    customerGroups: 'Müşteri grupları',
    industries: 'Sektörler',
    regions: 'Bölgeler',
    salesTerritories: 'Satış bölgeleri',
    revenueClasses: 'Gelir sınıfları',
    minimumDataCount: 'Minimum sipariş sayısı',
    activeFrom: 'Başlangıç',
    activeUntil: 'Bitiş',
    prospectStatuses: 'Aday durumları',
    riskStatuses: 'Risk ve engel durumları',
    weekdays: 'Değerlendirme günleri',
  },
  actions: actionsEn,
  weekdays: {
    '1': 'Pazartesi',
    '2': 'Salı',
    '3': 'Çarşamba',
    '4': 'Perşembe',
    '5': 'Cuma',
    '6': 'Cumartesi',
    '7': 'Pazar',
  },
  months: monthsEn,
  riskStatuses: riskEn,
} as const;
export const salesRuleAdminRu = {
  ...salesRuleAdminEn,
  title: 'Управление правилами продаж',
  subtitle: 'Безопасная настройка и проверка объяснимых рекомендаций.',
  tabs: {
    label: 'Управление правилами',
    rules: 'Правила',
    cadence: 'Ритм заказов',
    automation: 'Автоматизация и запуски',
  },
  rules: 'Правила продаж',
  newRule: 'Новое правило',
  search: 'Поиск правил',
  simulate: 'Запустить симуляцию',
  saved: 'Правило сохранено.',
  created: 'Правило создано в тестовом режиме.',
  restored: 'Версия восстановлена.',
  fields: {
    ...salesRuleAdminEn.fields,
    name: 'Название',
    type: 'Тип правила',
    priority: 'Базовый приоритет',
    action: 'Рекомендуемое действие',
    description: 'Описание',
    active: 'Правило активно',
    testMode: 'Тестовый режим',
    dueInDays: 'Срок через дней',
    expiresAfterDays: 'Истекает через дней',
    defaultResponsible: 'Ответственный по умолчанию',
    defaultTeam: 'Команда по умолчанию',
  },
  parameters: {
    ...parametersEn,
    thresholdDays: 'Порог в днях',
    comparisonDays: 'Период сравнения в днях',
    declinePercent: 'Снижение выручки в процентах',
    escalationAfterDays: 'Эскалация через дней',
    escalationPriority: 'Приоритет эскалации',
  },
  conditions: {
    ...conditionsEn,
    customerGroups: 'Группы клиентов',
    industries: 'Отрасли',
    regions: 'Регионы',
    salesTerritories: 'Территории продаж',
    revenueClasses: 'Классы выручки',
    minimumDataCount: 'Минимум заказов',
    activeFrom: 'Активно с',
    activeUntil: 'Активно до',
    prospectStatuses: 'Статусы лидов',
    riskStatuses: 'Статусы риска и блокировки',
    weekdays: 'Дни оценки',
  },
  actions: actionsEn,
  weekdays: {
    '1': 'Понедельник',
    '2': 'Вторник',
    '3': 'Среда',
    '4': 'Четверг',
    '5': 'Пятница',
    '6': 'Суббота',
    '7': 'Воскресенье',
  },
  months: monthsEn,
  riskStatuses: riskEn,
} as const;
